































import { ButtonType } from '@getaccept/lib-ui';
import { SigningHelper as SigningShared } from '@getaccept/lib-shared/src/signature/helpers/signing.helper';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import EIdIcon from '../../EIdIcon.vue';
import type { BankId } from '../../../types/bankid';
import { SigningHelper } from '../../../helpers/signing.helper';
import { BankIdStep } from '../../../types/enums/bankid-se';
import { EIdIconType } from '../../../types/enums/eid-icon-type';

export default defineComponent({
  components: {
    EIdIcon,
  },
  props: {
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
    jwt: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const bankIdAutoStartUrl = computed(() => {
      const baseUrl = 'bankid:///?autostarttoken=';
      if (SigningShared.isIOS() && !SigningShared.isSafari()) {
        const redirectUrl: string = SigningHelper.getBankIDiOSRedirectUrl(props.bankId, props.jwt);
        return `${baseUrl}${props.bankId.autoStartToken}&redirect=${encodeURIComponent(
          redirectUrl
        )}`;
      }
      return `${baseUrl}${props.bankId.autoStartToken}&redirect=null`;
    });

    const handleCancel = () => {
      emit('cancel');
    };

    return {
      handleCancel,
      bankIdAutoStartUrl,
      BankIdStep,
      ButtonType,
      EIdIconType,
    };
  },
});
